function updateCartLink()
{
    jQuery.getJSON("/cart.js", function(response) {
        if(typeof response.item_count !== "undefined") {
            jQuery(".header-bar .cart-count").text("(" + response.item_count + ")");
            if(response.item_count > 0) {
                jQuery(".header-bar .header-bar__cart-count").show();
                jQuery(".header-bar .cart-page-link").addClass("strobe-animation");
            } else {
                jQuery(".header-bar .cart-page-link").removeClass("strobe-animation");
            }
        }
    });
}

function popoverNotify(message)
{
    if(message.trim() !== "") {
        if(jQuery("#popover-notification-box").length > 0) {
            jQuery("#popover-notification-box").remove();
        }
        var box = "<div id='popover-notification-box'>" + message + "</div>"
        jQuery("body").append(box);
        setTimeout(function() {
            jQuery("#popover-notification-box").fadeOut("fast", function() {
                $(this).remove();
            });
        }, 3000);
    }
}